import { ExclamationCircle } from 'icons/ExclamationCircle';
import { useTranslations } from 'utils/translations/useTranslations';

const InvalidCardError = () => {
  const i18n = useTranslations();

  return (
    <div
      className="w-full bg-[#FBEAE5] mt-4 mb-8"
      data-testid="invalidCardMessage"
    >
      <div className="flex items-center gap-x-2 p-3">
        <ExclamationCircle aria-hidden={true} className="text-red-600" />
        <div className="text-sm">{i18n.t('cardForm.error.invalidCard')}</div>
      </div>
    </div>
  );
};

export { InvalidCardError };
